import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

import { getWorkspaceAlertsNavigationAllowed } from "../getWorkspaceAlertsNavigationAllowed";

const WorkspaceAlertsLandingPage = lazy(() =>
  import("@scenes/WorkspaceAlerts").then((module) => ({
    default: module.WorkspaceAlertsLandingPage,
  }))
);

export const workspaceAlertsNRO: NavigationRoutingObject = {
  Component: WorkspaceAlertsLandingPage,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("workspace-alerts-nro-heading", "Workspace Alerts"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("workspace-alerts-nro-description", "Configure the alerts your workspace receives from Braze"),
  tag: "new",
  pageNameForTracking: () => "Workspace Alerts",
  getDeveloperNavigationAllowed: getWorkspaceAlertsNavigationAllowed,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("workspace-alerts-nro-additional-keyword-alerts", "alerts"),
        t("workspace-alerts-nro-additional-keyword-notifications", "notifications"),
      ],
      description: t("workspace-alerts-nro-additional-description", "Workspace alerts"),
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/app_settings/app_settings/product_alerts/:appGroupId",
};
